module.exports = __webpack_public_path__ + "img/ma-back.ffb4201e.png";